import React, { createContext, useContext, useEffect, useState } from 'react';

// Tema giorno/notte a scelta dell'operatore. Preferenza salvata in localStorage
// (per browser/dispositivo, non sincronizzata sul server: ogni postazione può
// avere la sua). Applica/rimuove la classe `dark` su <html>, letta sia dalle
// variabili CSS dei componenti (shadcn) sia dagli override in index.css per le
// classi Tailwind dirette (bg-white, text-slate-*, ecc.) usate nelle pagine.
const ThemeContext = createContext(null);
const STORAGE_KEY = 'jvcrm_theme';

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved === 'light' || saved === 'dark') return saved;
    } catch (e) { /* localStorage non disponibile: fallback tema chiaro */ }
    return 'light';
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    try { localStorage.setItem(STORAGE_KEY, theme); } catch (e) { /* ignorato */ }
  }, [theme]);

  const setTheme = (t) => setThemeState(t === 'dark' ? 'dark' : 'light');
  const toggleTheme = () => setThemeState((prev) => (prev === 'dark' ? 'light' : 'dark'));

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme deve essere usato dentro <ThemeProvider>');
  return ctx;
};
